var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('modal-box',{attrs:{"id":"errorModal","title-translation-key":_vm.errorTitleTranslationKey,"template-body-instance":_vm.errorComponentInstance(),"close-callback":_vm.closeErrorModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }